/* =========================================== *\
 *  One to Many polymorphic Image model,
 *  stores data about a single image. Used in
 *  Residence and Illustration.
\* =========================================== */

import { Model } from '@vuex-orm/core';
import Date from '@/models/Date';
import Illustration from '@/models/Illustration';
import Imageable from '@/models/Imageable';
import ImageSize from '@/models/ImageSize';
import Option from '@/models/Option';
import Residence from '@/models/Residence';

export default class Image extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'images';

  static state() {
    return {
      cardImageSize: '',
    };
  }

  // List of all fields (schema) of the image model.
  static fields() {
    return {
      id: this.uid(),
      filename: this.attr(null),
      title: this.attr(null),
      alt: this.attr(null),
      caption: this.attr(null),
      description: this.attr(null),
      mime_type: this.attr(null),
      type: this.attr(null),
      subtype: this.attr(null),

      // Moved to ImageSize "full"
      url: this.attr(null),
      height: this.number(null),
      width: this.number(null),

      // Relationships
      date: this.morphOne(Date, 'dateable_id', 'dateable_type'),
      illustrations: this.morphedByMany(
        Illustration,
        Imageable,
        'image_id',
        'imageable_id',
        'imageable_type'
      ),
      options: this.morphedByMany(
        Option,
        Imageable,
        'image_id',
        'imageable_id',
        'imageable_type'
      ),
      residences: this.morphedByMany(
        Residence,
        Imageable,
        'image_id',
        'imageable_id',
        'imageable_type'
      ),
      sizes: this.hasMany(ImageSize, 'image_id'),
    };
  }
}
